<template>
  <div class="wrapper">
    <div class="topBox"></div>
    <div class="projectName">{{ projectName }}</div>
    <!-- 分期 -->
    <div class="selectAll">
      <div class="symbolSelect">
        <select
          class="proSelect"
          label="当前项目分期"
          v-model="proSelect"
          @change="chgProject($event)"
        >
          <option
            v-for="(item, index) in projects"
            :key="item.index"
            :value="index"
            >{{ item.periodName }}</option
          >
        </select>
        <span class="warnSymbol">当前项目分期:</span>
      </div>
      <p class="refresh" @click="refresh()"></p>
    </div>
    <!-- 楼栋 -->
    <div class="menu-layer" :class="{ seeMore: otherFlag }">
      <div
        v-for="(item, index) in showList.slice(0, 5)"
        :class="{ active: item.id == curBuildingId }"
        v-show="!seeMoreBuildFlag"
        @click="chgBuilding(index, item, 0)"
        :key="index"
      >
        {{ item.name }}
      </div>
      <div class="canClickBuild" v-show="seeMoreBuildFlag">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: item.id == curBuildingId }"
          @click="chgBuilding(index, item, 1)"
        >
          {{ item.name }}
        </div>
      </div>
      <p class="seeOther" @click="seeOther()"></p>
    </div>
    <!-- 单元 -->
    <div class="house-layer" v-if="houses.length > 0">
      <div class="unit-layer">
        <div
          class="unit"
          v-for="(item, index) in houses"
          :class="{ active: index == curUnitIdx }"
          :key="index"
          @click="chgUnit(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="houseRule">
        <p>价格说明</p>
        网上认购后可换房，同样享受《商品房优惠网上认购书》的权益，须在7日内签署《商品房认购书》，最终成交价以双方签署《商品房买卖合同》为准。
      </div>
      <div class="selectState">
        <select
          class="proSelect"
          label="关系"
          v-model="selectNum"
          @change="chanceNum"
        >
          <option
            v-for="item in stateList"
            :key="item.index"
            :value="item.value"
            >{{ item.name }}</option
          >
        </select>
      </div>
      <!-- 具体房号 -->
      <div class="house-block">
        <div
          class="house-item"
          v-for="(item, index) in houses[curUnitIdx].list"
          :key="index"
          @click="selectHouse(item)"
          :class="classObject(item)"
          v-show="item.saleState == selectNum || selectNum == 'all'"
        >
          <div class="houseTop">
            <p class="houseP">
              <b>房号:</b>
              <span class="houseAll" v-show="hasUnitFlag">{{ item.buildingName }}-{{ item.unit }}-{{item.saleFloorRoomName}}</span>
              <span class="houseAll" v-show="!hasUnitFlag">{{ item.buildingName }}-{{item.saleFloorRoomName}}</span>
              <span class="houseSaleState" :class="classObject(item)">{{
                item.saleState == 3
                  ? "认购中"
                  : item.saleState == 1
                  ? "未认购"
                  : "已售"
              }}</span>
            </p>
            <span class="noText">查看户型详情</span>
          </div>
          <div class="houseBottom clearfix">
            <div class="houseB1">
              <p>建面约:{{ item.planBuildArea }}</p>
              <p>户型:{{ item.houseTypeName }}</p>
            </div>
            <div class="houseB2">
              <p>装修:{{ item.decorateName }}</p>
              <p>单价:{{ item.houseFacePrice | getMoney2 }}</p>
            </div>
            <div class="houseB3">
              <p class="houseP1">总价约:</p>
              <p class="houseP2" :class="classObject(item)">
                {{ item.houseSumFacePrice | getMoney }}
              </p>
            </div>
          </div>
        </div>
        <p class="noHouseData" v-show="noFlag">该楼栋暂无此状态房源</p>
      </div>
    </div>
    <p class="noMore" v-show="noHouseFlag">暂无房源</p>
    <div class="noSee" v-show="conpanyFlag">
      <img :src="companyCode" class="bigImg" alt="" />
      <p class="clickSee" @click="clickSee">已关注公众号，点我刷新</p>
      <div class="seeSmall">
        <p class="companyImg"></p>
        <p class="companyText">
          请您长按<span style="color:#E6002D">扫码关注</span
          >，方便选房及后续服务
        </p>
        <img :src="companyCode" class="companyCode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import { MessageBox, Field, Indicator } from "mint-ui";
import request from "@/utils/request";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "./components/all.css";
export default {
  data() {
    return {
      projectid: this.$route.query.pid ? this.$route.query.pid : 2343,
      projectName: "", //项目名称
      projects: [],
      curProjectIdx: 0,
      list: [],
      showList: [],
      curBuildingId: "",
      curUnitIdx: 0,
      proSelect: 0,
      houses: [],
      proSelectPeriodName: "",
      referenceOpenid: this.$route.query.referenceOpenid
        ? this.$route.query.referenceOpenid
        : "",
      otherFlag: false, //判断是否查看更多楼栋
      stateList: [
        { name: "全    部", value: "all" },
        { name: "未认购", value: "1" },
        { name: "认购中", value: "3" },
        { name: "已    售", value: "4" }
        // { name: "已交楼", value: "5" },
      ],
      selectNum: "all",
      noFlag: false,
      noHouseFlag: false,
      companyCode: "",
      conpanyFlag: false,
      seeMoreBuildFlag: false,
      hasUnitFlag: true //判断是否有单元，用以显示具体房源名称等
    };
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "shareSpreadInfo",
      "receiveSpreadInfo",
      "rsCardInfo",
      "isShowGuide"
    ]),
    classObject() {
      return function(item) {
        switch (parseInt(item.saleState)) {
          case 0:
            return {
              i0: true
            };
            break;
          case 1:
            return {
              i1: true
            };
            break;
          case 2:
            return {
              i2: true
            };
            break;
          case 3:
            return {
              i3: true
            };
            break;
          case 4:
            return {
              i4: true
            };
            break;
          case 5:
            return {
              i5: true
            };
            break;
          default:
            break;
        }
      };
    }
  },
  watch: {},
  filters: {
    getMoney: function(value) {
      let a = (value / 10000).toFixed(0);
      return a + "万";
    },
    getMoney2: function(value) {
      let a = Number(value).toFixed(0);
      return a + "元/㎡";
    }
  },
  methods: {
    go(){
      let that = this;
      that.$router.push("register2?pid=" + that.projectid);
    },
    // 获取个人信息
    getUserInfo() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getUserInfo",
          requestParam: { projectId: that.projectid }
        })
        .then(function(data) {
          console.log(data.obj);
          if (data.obj) {
            that.getHouseData();
          } else {
            if (that.referenceOpenid == "") {
              that.$router.push("register2?pid=" + that.projectid);
            } else {
              that.$router.push(
                "register2?pid=" +
                  that.projectid +
                  "&referenceOpenid=" +
                  that.referenceOpenid
              );
            }
          }
        });
    },
    loadData() {
      let that = this;
      Indicator.open({
        text: "房源加载中...",
        spinnerType: "fading-circle"
      });
      request
        .get(
          `${that.global.API_URL}`,
          {
            action: "/hf/PurchasingPlanAction/getBuildingIdInfo",
            requestParam: {
              buildingId: that.curBuildingId
            }
          },
          {
            mask: true
          }
        )
        .then(response => {
          let houses = [];
          response.obj.floor.forEach(e => {
            e.rooms.forEach(o => {
              let flag = false;
              houses.forEach((j, index) => {
                if (j.name == o.unit) {
                  flag = true;
                  houses[index].list.push(o);
                }
              });
              if (!flag) {
                houses.push({
                  name: o.unit,
                  list: [o]
                });
              }
            });
          });
          console.log(houses);
          Indicator.close();
          that.houses = houses;
          that.getNoData();
        });
    },
    //选分期
    chgProject(event) {
      let that = this;
      let realList = [];
      // console.log(that.projects[event.target.value].periodName)
      that.proSelectPeriodName = that.projects[event.target.value].periodName
      console.log(event.target.value);
      let type = event.target.value;
      console.log(that.proSelect);
      console.log(type);
      console.log(that.curProjectIdx);
      if (type == that.curProjectIdx) {
        return;
      }
      that.curProjectIdx = type;
      that.curUnitIdx = 0;
      that.projects[type].list.forEach(item => {
      if(item.onlineState == '线上可售'){
          realList.push(item)
        }
      })
      that.list = realList;
      that.showList = realList;
      // that.list = that.projects[type].list;
      // that.showList = that.projects[type].list;
      console.log(that.showList)
      if (that.showList[0].isShowUnit && that.showList[0].isShowUnit == 1) {
        that.hasUnitFlag = true;
      } else {
        that.hasUnitFlag = false;
      }
      console.log(that.hasUnitFlag)
      if (that.list && that.list.length > 0) {
        that.curBuildingId = realList[0].id;
      }
      if (that.curBuildingId) {
        that.loadData();
      }
    },
    //选单元
    chgUnit(type) {
      let that = this;
      if (type == that.curUnitIdx) {
        return;
      }
      that.curUnitIdx = type;
      that.getNoData();
      console.log(that.houses);
    },
    // 查看更多楼栋
    seeOther() {
      let that = this;
      that.seeMoreBuildFlag = true;
      if (that.otherFlag) {
        that.otherFlag = false;
      } else {
        that.otherFlag = true;
      }
    },
    //选楼栋
    chgBuilding(index, item, num) {
      console.log(item);
      if (item.isShowUnit && item.isShowUnit == 1) {
        this.hasUnitFlag = true;
      } else {
        this.hasUnitFlag = false;
      }
      console.log(this.hasUnitFlag)
      if (num == 1) {
        this.showList = [];
        const floorNum = Math.floor(index / 5);
        console.log(this.list[floorNum * 5]);
        for (var i = 0; i < 5; i++) {
          if (this.list[floorNum * 5 + i]) {
            this.showList.push(this.list[floorNum * 5 + i]);
          }
        }
        console.log(this.showList);
      }
      if (item.id == this.curUnitIdx) return;
      this.curBuildingId = item.id;
      this.loadData();
      this.chgUnit(0);
      this.otherFlag = false;
      this.seeMoreBuildFlag = false;
    },
    selectHouse(item) {
      console.log(item.saleState);
      let that = this;
      if (item.saleState == 1) {
        localStorage.setItem("houseData", JSON.stringify(item));
        // that.$router.push(
        //   "houseSure?pid=" + that.projectid + "&houseCode=" + item.id
        // );
        that.$router.push(
          "register3?pid=" + that.projectid + "&houseCode=" + item.id
        );
      }
    },
    // 获取总信息
    getHouseData() {
      let that = this;
      let realList = [];
      Indicator.open({
        text: "房源加载中...",
        spinnerType: "fading-circle"
      });
      request
        .get(
          `${that.global.API_URL}`,
          {
            action: "/hf/PurchasingPlanAction/searchBuilding",
            requestParam: {
              projectid: parseInt(that.projectid)
            }
          },
          {
            mask: true
          }
        )
        .then(response => {
          console.log("response>>>>", response);
          that.projects = response.obj;
          that.projects[0].list.forEach(item => {
          if(item.onlineState == '线上可售'){
              realList.push(item)
            }
          })
          that.list = realList;
          that.showList = realList;
          that.proSelectPeriodName = that.projects[0].periodName
          console.log(that.showList);
          console.log(that.showList[0]);
          console.log(that.proSelectPeriodName)
          if (that.showList[0].isShowUnit && that.showList[0].isShowUnit == 1) {
            that.hasUnitFlag = true;
          } else {
            that.hasUnitFlag = false;
          }
          console.log(that.hasUnitFlag)
          if (that.list && that.list.length > 0) {
            // that.curBuildingId = that.projects[0].list[0].id;
            that.curBuildingId = realList[0].id;
            that.projectName = that.projects[0].list[0].projectName;
          }
          console.log(that.projectName)
          Cookies.set('shareName',that.projectName)
          console.log(that.curBuildingId);
          if (that.curBuildingId) {
            that.loadData();
          }
          Indicator.close();
          that.shareInit()
        });
    },
    refresh() {
      let that = this;
      that.getHouseData();
      that.proSelect = 0;
      that.curProjectIdx = 0;
      that.chgUnit(0);
      that.selectNum = "all";
    },
    chanceNum() {
      let that = this;
      console.log(that.selectNum);
      that.getNoData();
    },
    getNoData() {
      let that = this;
      let getNoData = [];
      let getNo = 0;
      // 新数组，用来处理未认购置顶
      let noSale = [];
      let canSale = [];
      // console.log(that.curUnitIdx)
      // console.log(that.houses[that.curUnitIdx].list)
      console.log(that.houses[that.curUnitIdx]);
      if (!that.houses[that.curUnitIdx]) {
        that.noHouseFlag = true;
        return;
      } else {
        that.noHouseFlag = false;
      }
      // 新需求，将未认购房源置顶
      that.houses[that.curUnitIdx].list.forEach(e =>{
        if(e.saleState == 1){
          noSale.push(e)
        }else{
          canSale.push(e)
        }
      })
      console.log(noSale);
      console.log(canSale);
      getNoData = noSale.concat(canSale);
      that.houses[that.curUnitIdx].list = noSale.concat(canSale)
      // getNoData = that.houses[that.curUnitIdx].list;
      console.log(getNoData);
      getNoData.forEach(item => {
        if (item.saleState == that.selectNum) {
          getNo++;
        }
      });
      console.log(getNo);
      if (getNo == 0) {
        if (that.selectNum == "all") {
          that.noFlag = false;
        } else {
          that.noFlag = true;
        }
      } else {
        that.noFlag = false;
      }
    },
    clickSee() {
      let that = this;
      that.hasSee();
    },
    hasSee() {
      let that = this;
      comreq.getUserInfo().then(function(userInfo) {
        console.log(userInfo);
        if (userInfo.user.state == 1) {
          that.conpanyFlag = false;
        } else {
          that.conpanyFlag = true;
        }
      });
    },
    shareInit() {
      let that = this;
      let shareLink = util.getUrlRemoveParams();
      //设置分享
      that.global.SHARE_TITLE = `${that.projectName}售楼中心，线上看房，实时咨询，欢迎您的光临！`;
      console.log(that.global.SHARE_TITLE);
      that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
      that.global.SHARE_IMG_URL =
        "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
      shareLink += `?pid=${this.projectid}&refereeopenid=${
        this.shareSpreadInfo.refereeopenid
      }`;
      that.global.SHARE_LINK = shareLink;
      console.log(shareLink);
      wxsdk.init();
    },
  },
  mounted() {
    let that = this;
    that.getUserInfo();
    console.log(that.global.OAUTH_IMG);
    that.companyCode = that.global.OAUTH_IMG;
    that.hasSee();
  }
};
</script>
<style lang="stylus" scoped>
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.wrapper {
  background-color: #FFFFFF;
  font-family:PingFang SC
}
.topBox{
  width 100%
  height 1.96rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/ttop2.png') no-repeat center
  background-size 6.7rem .84rem
  border-bottom .2rem solid #FAFAFA
}
.projectName{
  width 100%
  line-height .78rem
  text-align center
  font-weight bold
}
.selectAll{
  width 100%
  display flex
  justify-content space-around
  margin-bottom .36rem
}
.refresh{
  width .38rem
  height .42rem
  margin-top .1rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/reFresh.png') no-repeat center
  background-size 100% 100%
}
.symbolSelect{
  position relative
  width 6.24rem
  font-weight bold
}
.proSelect {
  width 100%
  min-height .65rem
  margin 0 auto
  display block
  appearance none
  -moz-appearance none
  -webkit-appearance none
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/botSelect2.png') no-repeat scroll 95% center
  background-size 0.3rem 0.3rem
  font-family PingFangSC-Regular
  color #E6002D
  border 2px solid #EEEEF0 !important
  border-radius 5px
  line-height .65rem
  text-indent 2.1rem
  font-size .28rem
  font-weight bold
}
.selectState .proSelect{
  width 1.5rem
  text-indent 0
  background-color white
  margin 0
  margin-left .4rem
  margin-bottom .2rem
  border-bottom 0
  border 0 !important
  color #333333
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/botSelect2.png') no-repeat scroll 80% 47%
  background-size 0.3rem 0.3rem
}
.warnSymbol{
  position absolute
  left 0.2rem
  top 0.05rem
  height 100%
  line-height .65rem
  color #333333
  font-weight bold
}
.houseRule{
  width 6.9rem
  padding .25rem .4rem
  box-sizing border-box
  background #F5F5F5
  color #E6002D
  margin 0 auto
  margin-bottom .36rem
  line-height .36rem
  font-size .22rem
  border-radius 15px
}
.houseRule p{
  line-height .6rem
  text-align center
  font-size .3rem
}
.menu-layer{
  width 100%
  padding-right 10%
  box-sizing border-box
  height .8rem
  line-height .8rem
  overflow hidden
  border-top 2px solid #F5F5F5
  border-bottom 2px solid #F5F5F5
  position relative
}
.menu-layer.seeMore{
  height 4rem
  overflow-y scroll
}
.menu-layer .active{
  color #E6002D
}
.seeOther{
  position absolute
  right 0
  top 0
  width 10%
  height .8rem
  background url(http://assets.rurushishi.com/yq-rs-make/huafasubscription/botSelect2.png) no-repeat center
  background-size: .4rem .4rem
}
.menu-layer div{
  width 20%
  float left
  text-align center
  font-size .28rem
  font-weight bold
}
.menu-layer .canClickBuild{
  width 100%
}
.unit-layer{
  height .7rem
  line-height .7rem
  width 100%
  overflow-x scroll
}
.unit-layer div{
  float left
  width 20%
  text-align center
}
.unit-layer .active{
  color #E6002D
}
.house-item{
  width 6.9rem
  padding .24rem
  margin 0 auto
  border 2px solid rgba(245,245,245,1)
  margin-bottom .2rem
  border-radius 5px
  box-sizing border-box
}
.house-item.i0{
  display none
}
.house-item.i3{
  color #666666
  background #F5F5F5
}
.house-item.i4,.house-item.i5{
  color #999999
}
.houseTop{
  width 100%
  display flex
  justify-content space-between
  margin-bottom .24rem
}
.houseP{
  font-size .3rem
  line-height .4rem
}
.house-item.i3 .houseAll{
  color #666666
  margin-right .2rem
}
.house-item.i1 .houseAll{
  color #32B16C
  margin-right .2rem
}
.house-item.i4 .houseAll,.house-item.i5 .houseAll{
  color #999999
  margin-right .2rem
}
.house-item.i2{
  display none
}
.houseP b{
  font-size .24rem
}
.noText{
  font-size .2rem
  line-height .4rem
}
.house-item.i3 .noText{
  color #666666
}
.house-item.i4 .noText,.house-item.i5 .noText,.house-item.i1 .noText{
  color #00479D
}
.houseSaleState{
  width 1.18rem
  text-align center
  display inline-block
  color white
  line-height .4rem
  font-size .24rem
  border-radius 5px
}
.houseSaleState.i3{
  background #EB8C58
}
.houseSaleState.i1{
  background #32B16C
}
.houseSaleState.i4,.houseSaleState.i5{
  background #C2C2C2
}
.noHouseData,.noMore{
  width 100%
  height 3rem
  line-height 3rem
  text-align center
  font-weight bold
  font-size .36rem
}
.houseB1,.houseB2{
  width 2.2rem
  border-right .04rem solid #F5F5F5
  float left
}
.houseB2{
  width 2.4rem
}
.houseB1 p,.houseB2 p{
  width 100%
  line-height .5rem
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
}
.houseB2 p{
  text-indent .2rem
}
.houseB3{
  text-indent .2rem
  text-align right
}
.houseB3 p{
  line-height .5rem
}
.houseB3 p.houseP2{
  font-size .36rem
  font-weight bold
}
.houseB3 p.houseP2.i3{
  color #333333
}
.houseB3 p.houseP2.i1{
  color #E6002D
}
.houseB3 p.houseP2.i4{
  color #666666
}
.noSee{
  width 100%
  height 100%
  position fixed
  left 0
  top 0
  background rgba(0,0,0,.9)
}
.seeSmall{
  width 5.46rem
  height 8.35rem
  position absolute
  left 0
  top 0
  right 0
  bottom 0
  margin auto
  background white
  border-radius 10px
}
.companyImg{
  width 5.46rem
  height 4.98rem
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/companyImg.png') no-repeat center
  background-size 100% 100%
  border-top-left-radius 10px
  border-top-right-radius 10px
}
.companyText{
  line-height .36rem
  font-size .24rem
  width 100%
  text-align center
  margin .2rem 0
}
.noSee .companyCode{
  width 1.86rem
  height 1.86rem
  display block
  margin 0 auto
}
.noSee .bigImg{
  width 100%
  height 100%
  display block
  position absolute
  left 0
  top 0
  right 0
  bottom 0
  margin auto
  opacity 0
  z-index 998
  -webkit-touch-callout none
}
.clickSee{
  position absolute
  z-index 999
  color white
  width 100%
  text-align center
  line-height .6rem
}
</style>
